import { useMemo, type FC } from 'react'
import { useCustomerTaxDocumentsDates } from '@egw/api'
import { useTranslation } from '@egw/i18n'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import { WEALTH_ROUTES } from '@egw/constants'
import { ListLink } from '../list-link/list-link'

export interface DocumentCenterDocument {
  name: string
  rank: number | null
  url: string
}

export const Tax: FC = () => {
  const { t } = useTranslation('features-documents')
  const { data, isLoading } = useCustomerTaxDocumentsDates()
  const legalTaxDoxs = useMemo(
    () =>
      data?.years.map((year) => ({
        name: year,
        url: `${WEALTH_ROUTES.DOCUMENTS_TAXES_YEAR.path}?year=${year}`,
        rank: null,
      })),
    [data],
  )

  return (
    <>
      <h2 className="mb-4 mt-10 text-2xl font-semibold">{t('tax.title')}</h2>
      {isLoading ? (
        <SkeletonTheme baseColor="#eeefee" highlightColor="rgba(255, 255, 255, 0.5)">
          <Skeleton count={1} height="50px" />
        </SkeletonTheme>
      ) : null}

      {!isLoading && (
        <>
          {legalTaxDoxs?.length ? (
            legalTaxDoxs.map((item) => <ListLink key={item.name} to={item.url} title={item.name} />)
          ) : (
            <div className="bg-bglight text-body px-3 py-3.5">{t('tax.no_documents')}</div>
          )}
        </>
      )}
    </>
  )
}
